import React, { useEffect, useState } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import DataTable from 'react-data-table-component'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CSVLink } from 'react-csv'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { Link, useNavigate } from 'react-router-dom'

export const FindApplication = () => {
  // filter data based on dates,HR/Final/Interview status
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [hrStatus, setHrStatus] = useState([])
  const [finalStatus, setFinalStatus] = useState([])
  const [round, setRound] = useState([])
  const [hr, setHR] = useState([])
  const token = localStorage.getItem('token')
  // input values
  const [values, setValues] = useState({
    from: '',
    to: '',
    status_hr: '',
    interview_round: '',
    final_status: '',
    owner_name: '',
  })

  const currentDate = new Date().toISOString().split('T')[0]

  // onchange input
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  useEffect(() => {
    applications()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // fetch all applications
  const applications = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchTableData', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setData(response.data.data)
        setFilteredData(response.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  // get HR/Final/Interview status
  const getvalues = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchHRStatus', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHrStatus(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchInterviewRound', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setRound(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchFinalStatus', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setFinalStatus(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchHRData', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHR(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
  }
  useEffect(() => {
    getvalues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // columns to display data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {row.candidate_name}
            </p>
          </Tippy>
        )
      },
    },

    {
      name: 'Designation',
      cell: (row) => {
        return (
          <Tippy content={row.designation} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {row.designation}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Applied date',
      cell: (row) => {
        return (
          <Tippy content={row.applied_date} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {moment(row.applied_date).format('DD-MM-YYYY')}
            </p>
          </Tippy>
        )
      },

      width: '130px',
    },
    {
      name: 'HR Status',
      selector: (row) => row.status_hr,
      sortable: true,
      width: '110px',
    },
    {
      name: 'Interview Round',
      selector: (row) => row.interview_round,
      sortable: true,
      width: '130px',
    },
    {
      name: 'Final Status',
      cell: (row) => {
        return (
          <Tippy content={row.final_status} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.final_status}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Interviewer Name',
      cell: (row) => {
        return (
          <Tippy content={row.interviewer_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {row.interviewer_name}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Assigned Owner',
      cell: (row) => {
        return (
          <Tippy content={row.owner_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {row.owner_name}
            </p>
          </Tippy>
        )
      },
    },
  ]

  // formating date and contact for csv file
  const formatdata = data.map((row) => ({
    ...row,
    applied_date: moment(row.applied_date).format('YYYY-MM-DD'),
    contact: `=""${row.contact}""`,
  }))

  // filter data based on dropdown selection
  useEffect(() => {
    const result = data.filter((item) => {
      if (
        (values.from === '' || values.to === '') &&
        item.owner_name !== null
      ) {
        return (
          item.status_hr.match(values.status_hr) &&
          item.interview_round.match(values.interview_round) &&
          item.final_status.match(values.final_status) &&
          item.owner_name.match(values.owner_name)
        )
      } else if (
        values.from !== '' &&
        values.to !== '' &&
        item.owner_name !== null
      ) {
        return (
          new Date(item.applied_date) >= new Date(values.from) &&
          new Date(item.applied_date) <= new Date(values.to) &&
          item.status_hr.match(values.status_hr) &&
          item.interview_round.match(values.interview_round) &&
          item.final_status.match(values.final_status) &&
          item.owner_name.match(values.owner_name)
        )
      }

      return false
    })

    setFilteredData(result)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])
  return (
    <>
      <Sidebar />

      <div className="container findApplication mt-5">
        <div className=" mt-3 mb-5">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </nav>
        </div>
        <div className="row mb-2">
          <div className="col-md-2">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              From
            </label>
            <input
              type="date"
              className="form-control"
              name="from"
              value={values.from}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-2">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              To
            </label>
            <input
              type="date"
              className="form-control"
              name="to"
              value={values.to}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-2">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              HR Status
            </label>
            <select
              className="form-select"
              id="floatingSelectGrid"
              name="status_hr"
              value={values.status_hr}
              onChange={handleChange}
            >
              <option value="" disabled selected>
                {' '}
                Select{' '}
              </option>
              {hrStatus?.map((i, index) => {
                return (
                  <option value={i.value} key={index}>
                    {i.name}
                  </option>
                )
              })}
            </select>
          </div>
          <div className="col-md-2">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Interview Round
            </label>
            <select
              className="form-select"
              id="floatingSelectGrid"
              name="interview_round"
              value={values.interview_round}
              onChange={handleChange}
            >
              <option value="" disabled selected>
                {' '}
                Select{' '}
              </option>
              {round?.map((i, index) => {
                return (
                  <option value={i.value} key={index}>
                    {i.name}
                  </option>
                )
              })}
            </select>
          </div>
          <div className="col-md-2">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Final Status
            </label>
            <select
              className="form-select"
              id="floatingSelectGrid"
              name="final_status"
              value={values.final_status}
              onChange={handleChange}
            >
              <option value="" disabled selected>
                {' '}
                Select
              </option>
              {finalStatus?.map((i, index) => {
                return (
                  <option value={i.value} key={index}>
                    {i.name}
                  </option>
                )
              })}
            </select>
          </div>
          <div className="col-md-2">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Assigned Owner
            </label>
            <select
              className="form-select"
              id="floatingSelectGrid"
              name="owner_name"
              value={values.owner_name}
              onChange={handleChange}
            >
              <option value="" disabled selected>
                {' '}
                Select
              </option>
              {hr?.map((i, index) => {
                return (
                  <option value={i.name} key={index}>
                    {i.name}
                  </option>
                )
              })}
            </select>
          </div>
        </div>
        <div className="row d-flex justify-content-end mb-4">
          <div class="d-grid gap-2 d-md-flex justify-content-end">
            {/* export data file */}
            <CSVLink
              data={formatdata}
              filename={'Applications - ' + currentDate}
            >
              <button className="btn btn-primary">Export</button>
            </CSVLink>
            <button
              className="btn btn-primary me-md-2"
              onClick={() => applications()}
            >
              Initial data
            </button>
          </div>
        </div>

        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
        />
      </div>
    </>
  )
}
